module.exports = __webpack_public_path__ + "img/img2.23ea8194.jpg";